import { render, staticRenderFns } from "./o-job-detail.vue?vue&type=template&id=3b613cf7&scoped=true"
import script from "./o-job-detail.vue?vue&type=script&lang=js"
export * from "./o-job-detail.vue?vue&type=script&lang=js"
import style0 from "./o-job-detail.vue?vue&type=style&index=0&id=3b613cf7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b613cf7",
  null
  
)

export default component.exports